import useFetchedConfigurations from 'hooks/use-fetched-configurations';
import { hasAnyFilterableDimension } from './equipment-comparison-filters';
import EquipmentConfigFilter from './equipment-config-filter';
import EquipmentFiltersMenu from './equipment-filters-menu';
import useEquipmentFilters from './use-equipment-filters';

type EquipmentFiltersControlsProps = Readonly<{
  // Ducted path (AHA-6681 QA F6): the scoped ducted section owns 'System
  // Type' there, so the legacy dimension is excluded from both the menu and
  // the show/hide decision (it must not keep the menu alive on its own).
  hideSystemTypeSection?: boolean;
}>;

export default function EquipmentFiltersControls({
  hideSystemTypeSection = false
}: EquipmentFiltersControlsProps) {
  const fetchedConfigurations = useFetchedConfigurations();
  const {
    universe,
    filterState,
    setFilterState,
    condenserSeriesLabels,
    optionCounts
  } = useEquipmentFilters();

  const showConfigFilter = fetchedConfigurations.length >= 2;
  const showDimensionFilters = hasAnyFilterableDimension(
    hideSystemTypeSection ? { ...universe, systemTypes: [] } : universe
  );

  if (!showConfigFilter && !showDimensionFilters) {
    return null;
  }

  return (
    <div className='flex flex-col'>
      <EquipmentConfigFilter state={filterState} onChange={setFilterState} />
      {showDimensionFilters && (
        <EquipmentFiltersMenu
          universe={universe}
          state={filterState}
          onChange={setFilterState}
          condenserSeriesLabels={condenserSeriesLabels}
          optionCounts={optionCounts}
          hideSystemTypeSection={hideSystemTypeSection}
        />
      )}
    </div>
  );
}
